export enum PaymentLocale {
    CHINESE_SIMPLIFIED = 'zh_CN',
    CHINESE_TRADITIONAL = 'zh_TW',
    ENGLISH = 'EN',
}
